// overlay.js

$(function() {

	var scroll = $(window).scrollTop(),
		overlaySelector = '.overlay',
		overlayContentSelector = '.overlay__content',
		overlayAutomaticContentSelector = '.overlay__content--auto',
		overlay = $(overlaySelector),
		content = overlay.find(overlayContentSelector),
		contentAutomatic = $(overlayAutomaticContentSelector);

	$(document).on('click', '.js-overlay-open', function(event) {
		var item = $(this),
			data = item.data();

		scroll = $(window).scrollTop();

		overlay.trigger('open.overlay', {
			scroll: scroll,
			itemData: data,
			auto: false
		});

		event.preventDefault();
	});

	$(document).on('click', '.js-overlay-close', function(event) {
		event.preventDefault();

		var elem = $(this);
		overlay.trigger('close.overlay', {
			href: elem.attr('href'),
			title: elem.attr('title')
		});

	});

	// setup handler
	overlay.one('setup.overlay', function() {

		if(contentAutomatic.children().length) {
			
			overlay.trigger('open.overlay', {
				scroll: scroll,
				itemData: {
					content: contentAutomatic.html(),
					backHref: contentAutomatic.attr('data-href'),
					backTitle: contentAutomatic.attr('data-title')
				},
				auto: true
			});

		} else {
			overlay.trigger('reset.overlay');
		}

	});

	// reset handler
	overlay.on('reset.overlay', function() {
		content.html('');
	});

	// close handler
	// overlay.add(document).on('close.overlay', function(event, data) {
	overlay.on('close.overlay', function(event, data) {

		$('.page').removeClass('overlay-open');
		$('.page__stage').css('top', 'auto');
		$(window).scrollTop(scroll);
		overlay.trigger('reset.overlay');

		setNav(data.href, data.title, 'closeOvl');

	});

	// populate handler
	overlay.on('populate.overlay', function(event, data) {
		
		var overlayData = '';

		overlay.trigger('reset.overlay');

		if(!data.auto) {

			switch (data.itemData.overlayType) {
				case 'news':

					$.ajax(data.itemData.src).done(function(response) {

						overlayData = $('<div/>').append($.parseHTML(response)).find(overlayAutomaticContentSelector).html();
						
						content.append(overlayData);

						Main.initPlugins(content, true);

					});

					break;
				case 'image':
					overlayData = '<img src="' + data.itemData.src + '" alt="Detail" />';
					content.append(overlayData);
					break;
				case 'video':
					/*overlayData = '<video poster="' + data.itemData.poster + '" controls="controls">\
										<source type="video/mp4" src="' + data.itemData.src + '" />\
									</video>';
					*/
					overlayData = '<iframe src="https://player.vimeo.com/video/' + data.itemData.videoid + '" width="640" height="480" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
					content.append(overlayData);
					break;
				default:
					console.log('no content');
			}

		} else {

			overlayData = data.itemData.content;
			content.append(overlayData);

			Main.initPlugins(content, true);

		}

		overlay.find('.js-overlay-close').attr({
			href: data.itemData.backHref,
			title: data.itemData.backTitle
		});

	});

	overlay.on('open.overlay', function(event, data) {

		if(data) {
			overlay.trigger('populate.overlay', data);
		}

		$('.page').addClass('overlay-open');
		$('.page__stage').css('top', '-' + data.scroll + 'px');

	});

	overlay.trigger('setup.overlay');

});

// nav.js

function nav( $el ) {
	this.$el = $el;
};

nav.prototype = {
	constructor: nav,

	initView: function(){

		var $this = this,
			target = $($this.$el.attr('data-target')),
			parent = target.parent();

		detachMenu = function(target) {
			var menu = parent.detach();
			menu.insertAfter(target);
		};

		enquire.register("screen and (max-width: 767px)", {
			match : function() {
				// mobile
				detachMenu('.page__canvas');
			},
			unmatch : function() {
				// desktop
				detachMenu('.page__header .page__logo');
				$('html').removeClass('nav-is-visible');
			}
		});

		// thumbnail click
		$this.$el.on('click', function(event) {

			$('html').toggleClass('nav-is-visible');

			event.preventDefault();
		});

	},
	init: function(){
		this.initView();
	}

}

// lang-switch.js

$(function() {

	$(document).on('click', '.js-lang-switch', function(event) {

		var link = $(this),
			target = $(link.attr('data-target'));

		target.toggleClass('active');

		event.preventDefault();
	});

	$(document).click(function(e) {
		if ( $(e.target).closest('.menu--lang, .js-lang-switch').length === 0 ) {
			$('.menu--lang').removeClass('active');
		}
	});

});

// hero.js

function hero( $el ) {
	this.$el = $el;
};

hero.prototype = {
	constructor: hero,

	initView: function(){

		var $this = this;

		$this.$el.removeClass('prejs');

		$this.$el.owlCarousel({
			navigation: 		false,
			slideSpeed: 		300,
			paginationSpeed: 	400,
			singleItem: 		true,
			autoPlay: 			false
		});

	},
	init: function(){
		this.initView();
	}

}

// history.js

function history( $el ) {
	this.$el = $el;
};

history.prototype = {
	constructor: history,

	initView: function(){

		var $this = this;

		var $gal   = $this.$el,
			galW   = $gal.outerWidth(true),
			galSW  = $gal[0].scrollWidth,
			wDiff  = (galSW/galW)-1,  // widths difference ratio
			mPadd  = 60,  // Mousemove Padding
			damp   = 20,  // Mousemove response softness
			mX     = 0,   // Real mouse position
			mX2    = 0,   // Modified mouse position
			posX   = 0,
			mmAA   = galW-(mPadd*2), // The mousemove available area
			mmAAr  = (galW/mmAA);    // get available mousemove fidderence ratio

		$('.section--history').mousemove(function(e) {
			mX = e.pageX - $(this).parent().offset().left - this.offsetLeft;
			mX2 = Math.min( Math.max(0, mX-mPadd), mmAA ) * mmAAr;
		});

		setInterval(function(){
			posX += (mX2 - posX) / damp;
			$gal.css('left', posX*wDiff*(-1));
		}, 10);

		$(window).on('resize', function(){
			galW 	= $gal.outerWidth(true);
			galSW 	= $gal[0].scrollWidth;
			wDiff 	= (galSW/galW)-1;
			mmAA 	= galW-(mPadd*2);
			mmAAr 	= (galW/mmAA);
		});
		

		var showInfo = function(trigger) {

			var parentSelector = '.history__milestone';
				infoSelector = '.milestone__info',
				parent = trigger.parent(parentSelector);

			parent.toggleClass('active');
		}

		$this.$el.find('.js-milestone-trigger').on({
			mouseenter: function () {
				showInfo($(this));
			},
			mouseleave: function () {
				showInfo($(this));
			}
		});

	},
	init: function(){
		this.initView();
	}

}

// testimonials.js

function testimonials( $el ) {
	this.$el = $el;
};

testimonials.prototype = {
	constructor: testimonials,

	initView: function(){

		var $this = this;

		enquire.register('screen and (min-width: 769px)', {

			deferSetup : true,
			setup : function() {

			},
			match : function() {
				$this.$el.owlCarousel({
					items: 				3,
					itemsDesktop: 		false,
					itemsDesktopSmall: 	false,
					itemsTablet: 		[768,1],
					itemsMobile: 		false,
					navigation: 		true,
					navigationText: 	false,
					pagination: 		false
				});
			},
			unmatch : function() {
				$this.$el.data('owlCarousel').destroy();
			}

		});

	},
	init: function(){
		this.initView();
	}

}

// team.js

function team( $el ) {
	this.$el = $el,
	this.item_selector = '.team__item',
	this.member_selector = '.team__member',
	this.$members = this.$el.find(this.member_selector);
};

team.prototype = {
	constructor: team,

	initView: function(){

		var $this = this;
/*
			,
			$filter = '.business';

		$this.$el.isotope({
			itemSelector: $this.item_selector,
			filter: $filter
		});

		var filterLink = $('.team__filter').find('.filter__link');

		filterLink.on('click', function(event) {
			
			var link = $(this);

			$filter = link.data('filter');

			filterLink.not(this).removeClass('active');
			link.addClass('active');

			$this.$el.isotope({
				filter: $filter
			});

			event.preventDefault();
		});
		
		$this.$members.on('click', function() {
			var item = $(this);

			$this.$members.removeClass('active');
			item.addClass('active');

		});
*/

		var row = 1;

		setInterval(function() {

			var itemToChange;
			var lang = $('.team__row.row-' + row).attr('data-lang');
		
			var $currentItems = $('.team__row.row-' + row + ' .team__member');
			var currentIDs = "";
			$currentItems.each(function(){
				currentIDs += $(this).attr('data-id') + ',';
			});
			currentIDs = currentIDs.substring(0, currentIDs.length - 1);
			
			var currentRow = row;
			var $itemToChange;
			
			var max = $('.team__row.row-' + currentRow + ' .team__item:visible').length;
			var nr = Math.floor((Math.random() * max));
			$itemToChange = $('.team__row.row-' + currentRow + ' .team__item .team__member').eq(nr);
			
			// api - get random item
			$.ajax({
				url: '/api/get-teammember',
				type: 'post',
				data: { row: currentRow, current: currentIDs, lang: lang },
				success:function(response) {

					$itemToChange.before(response);
					
					$itemToChange.fadeOut('slow', function() {
						$itemToChange.detach();
					});
					
					row = row + 1;
					if(row > 3) row = 1;

				}
			});

		},3000);

	},
	init: function(){
		this.initView();
	}

}

// lifestyle.js

function lifestyle( $el ) {
	this.$el = $el;
	this.buttonSelector = '.js-lifestyle-content-switch';
	this.contentContainerSelector = '.lifestyle__display-inner';
};

lifestyle.prototype = {
	constructor: lifestyle,

	initView: function(){

		var $this = this,
			pillarList = $this.$el.find('.pillar__list'),
			contentContainer = $this.$el.find($this.contentContainerSelector),
			button = $this.$el.find($this.buttonSelector);

		if(pillarList.length) {
			pillarList.owlCarousel({
				navigation: 		false,
				slideSpeed: 		300,
				paginationSpeed: 	400,
				singleItem: 		true,
				autoPlay: 			true
			});
		}

		button.on('click', function(event) {

			if(!$(this).hasClass('active')) {

				var content = $(this).parents('.lifestyle__item').find('.lifestyle__content').html();

				button.removeClass('active');
				$(this).addClass('active');

				contentContainer.animate({
					opacity: 0
				}, {
					duration: 300,
					complete: function() {
						contentContainer.html('');
						contentContainer.html(content);

						contentContainer.animate({
							opacity: 1
						}, {
							duration: 300
						});
					}
				});

			}

			event.preventDefault();
		});

	},
	init: function(){
		this.initView();
	}

}

// social.js

function socialhub( $el ) {
	this.$el = $el;
};

socialhub.prototype = {
	constructor: socialhub,

	initView: function(){

		var $this = this;

		$this.$el.isotope({
			itemSelector: '.social__item',
			layoutMode: 'masonry',
			filter: '.new'
		});

		var filterLink = $('.social__filter').find('.filter__link');


		filterLink.on('click', function(event) {
			
			var link = $(this),
				filter = link.data('filter');

			filterLink.not(this).removeClass('active');
			link.addClass('active');

			$this.$el.isotope({ filter: filter });

			event.preventDefault()
		});

	},
	init: function(){
		this.initView();
	}

}

// events.js

function events( $el ) {
	this.$el = $el;
};

events.prototype = {
	constructor: events,

	initView: function(){

		var $this = this;

		var map,
			mapSelector = '.map',
			myLatlng = new google.maps.LatLng(-34.397, 150.644),
			mapStyles = [
				{
					"featureType": "water",
					"stylers": [
						{ "visibility": "on" },
						{ "color": "#f2f2f2" }
					]
				},
				{
					"featureType": "administrative",
					"stylers": [
						{ "visibility": "off" }
					]
				},
				{
					"featureType": "landscape",
					"stylers": [
						{ "visibility": "on" },
						{ "color": "#e4e4e4" }
					]
				},
				{
					"featureType": "road",
					"stylers": [
						{ "visibility": "off" }
					]
				},
				{
					"featureType": "transit",
					"stylers": [
						{ "visibility": "off" }
					]
				},
				{
					"featureType": "poi",
					"stylers": [
						{ "visibility": "off" }
					]
				}
			],
			mapOptions = {
				zoom: 				4,
				styles: 			mapStyles,
				mapTypeId: 			google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: 	true,
				scrollwheel: 		false,
			},
			//eventLocations = $.parseJSON('{"upcoming": [{"title": "Italy","lat": "41.926979","lng": "12.517385", "id": "upcoming-italy"},{"title": "Germany","lat": "51.914873","lng": "12.506486", "id": "upcoming-germany"},{"title": "Sweden","lat": "61.918574","lng": "12.507201", "id": "upcoming-sweden"}],"recent": [{"title": "Italy","lat": "41.926979","lng": "13.517385", "id": "recent-italy"},{"title": "Germany","lat": "51.914873","lng": "13.506486", "id": "recent-germany"},{"title": "Sweden","lat": "61.918574","lng": "13.507201", "id": "recent-sweden"}]}'),
			eventLocations,
			markerColors = {
				'upcoming': '#01b8d6',
				'recent': '#4bc9c5'
			},
			markers = {
				'upcoming': {},
				'recent': {}
			},
			mapFilter = $('.js-map-filter'),
			bounds,
			language = $('html').attr('lang');

		function initialize() {
			map = new google.maps.Map(document.getElementById('map'), mapOptions);

			var lang = $('html').attr('lang');

			// api - get events
			$.ajax({
				url: '/api/get-events-all',
				data: {lang: lang},
				type: 'post',
				success:function(response) {
					eventLocations = response;

					setMarkers(map);
				}
			});
		}

		function setMarkers(map, filter, initAnimation) {

			filter = typeof filter !== 'undefined' ? filter : 'upcoming';
			initAnimation = typeof initAnimation !== 'undefined' ? initAnimation : true;

			bounds = new google.maps.LatLngBounds();

			var markerIcon = {
					path: 'M19.451,12.885c1.207-3.398,0.433-7.337-2.383-10.043c-3.899-3.789-10.242-3.789-14.141,0\
					c-2.785,2.706-3.59,6.645-2.383,10.043c2.599,7.276,9.469,14.16,9.469,14.16s6.808-6.825,9.408-14.041L19.451,12.885z\
					 M12.148,12.402c-1.176,1.143-3.094,1.143-4.239,0c-1.176-1.142-1.176-3.007,0-4.119c1.176-1.142,3.094-1.142,4.239,0\
					C13.324,9.426,13.324,11.261,12.148,12.402z',
					fillColor: markerColors[filter],
					fillOpacity: 1,
					scale: 1.2,
					strokeWeight: 0,
					size: new google.maps.Size(20, 27),
					origin: new google.maps.Point(0,0),
					anchor: new google.maps.Point(10, 27)
				};

			for (i = 0; i < eventLocations[filter].length; i++) {
				marker = new google.maps.Marker({
					position: new google.maps.LatLng(eventLocations[filter][i].event_location_lat, eventLocations[filter][i].event_location_lng),
					icon: markerIcon,
					map: map,
					id: eventLocations[filter][i].event_id
				});

				google.maps.event.addListener(marker, 'click', (function(marker, i) {

					return function() {

						var section = $('.section--events'),
							section_height = section.outerHeight(),
							container = $('.events'),
							container_height = container.outerHeight(),
							container_pos = container.position(),
							container_top = container_pos.top,
							offsetY;

						offsetY = (container_top + (container_height/2)) - (section_height / 2) + 10;

						map.setCenter(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
						map.panBy(70, -offsetY);

					}
				})(marker, i));

				markers[filter][eventLocations[filter][i].event_id] = marker;

				bounds.extend(marker.position);
			}

			if(initAnimation) {
				map.fitBounds(bounds);

				var listener = google.maps.event.addListener(map, "idle", function () {
					map.setZoom(4);
					map.panBy($('.section--events').outerWidth()/4, 0);
					google.maps.event.removeListener(listener);
				});
			}
		}

		function resetMap() {
			map.fitBounds(bounds);
			map.setZoom(4);
			map.panBy($('.section--events').outerWidth()/4, 0);
		}

		// Sets the map on all markers in the array.
		function setAllMap(map, filter) {
			$.each(markers[filter], function(index) {
				markers[filter][index].setMap(map);
			});
		}

		// Removes the markers from the map, but keeps them in the array.
		function clearMarkers(filter) {
			setAllMap(null, filter);
			markers[filter] = {};
		}

		function fillTable(filter, lang) {
			$.ajax({
				url: '/api/get-events',
				type: 'post',
				data: {filter: filter, lang: lang},
				success:function(response) {

					dataTable.clear();

					$.each(response, function(index, item) {
						dataTable.row.add($(item));
					});

					dataTable.draw();

				}
			});
		}

		mapFilter.on('click', function(event) {

			var item = $(this),
				currentFilter = mapFilter.filter('.active').attr('data-filter'),
				newfilter = item.attr('data-filter'),
				eventDetail = $('.events__detail');

			if(!item.hasClass('active')) {
				mapFilter.removeClass('active');
				item.addClass('active');

				clearMarkers(currentFilter);
				setMarkers(map, newfilter, false);	
				
				console.log($('html').attr('lang'));
	
				fillTable(newfilter, language);
				

				eventDetail.removeClass('events__detail--' + currentFilter);
				eventDetail.addClass('events__detail--' + newfilter);
			}

			event.preventDefault();
		});


		var dataTable = $('#table_id').DataTable({
			autoWidth: 	false,
			dom: 		'<"events__search"fl>t<"clear">',
			info: 		false,
			language: {
				search: '<i class="icon icon--search"></i>_INPUT_',
				searchPlaceholder: "Search",
				zeroRecords: 'No events found'
			},
			ordering: 	false,
			paging: 	false,
			responsive: {
				details: false
			},
			scrollY: 	500
		});


		var eventDetail = $('.events__detail'),
			content 	= eventDetail.find('.events__content');


		function setArticleHeight() {
			if(eventDetail.is(':visible')) {
				console.log(eventDetail.find('.events__content-inner').height());
				eventDetail.find('.detail__article').height(eventDetail.find('.events__content-inner').height() - eventDetail.find('.detail__header').height());
			}
		}

		$(window).on('resize', function() {
			setArticleHeight();
		});

		// setup handler
		eventDetail.one('setup.detail', function() {
			if(content.children().length) {
				eventDetail.trigger('open.detail');
			} else {
				eventDetail.trigger('reset.detail');
			}
		});

		// reset handler
		eventDetail.on('reset.detail', function() {
			content.html('');
		});


		// close handler
		eventDetail.add(document).on('close.detail', function(event) {

			resetMap();

			eventDetail.fadeOut(250,function(){
				eventDetail.trigger('reset.detail');
			});
		});

		// populate handler
		eventDetail.on('populate.detail', function(event, data) {
			eventDetail.trigger('reset.detail');
			content.append(data);
		});

		eventDetail.on('open.detail', function(event, data) {
			eventDetail.trigger('populate.detail', data);

			eventDetail.fadeIn(250,function() {
				setArticleHeight();
			});
		});

		$(document).on('click', '.js-event-detail-open', function(event) {

			var item = $(this),
				event_id = item.attr('data-event'),
				filter = item.attr('data-type');

			$.ajax({
				url: '/api/get-event-detail',
				type: 'post',
				data: {id: event_id, lang: language},
				success:function(response) {

					//console.log(response);

					google.maps.event.trigger(markers[filter][event_id], 'click');
					eventDetail.trigger('open.detail', response);

				}
			});

			event.preventDefault();
		});

		$('.js-event-detail-close').on('click', function(event) {
			eventDetail.trigger('close.detail');

			event.preventDefault();
		});

		// initialize map on window load
		//google.maps.event.addDomListener(window, 'load', initialize);
		initialize();

	},
	init: function(){
		this.initView();
	}

}


// media.js

function media( $el ) {
	this.$el = $el;
};

media.prototype = {
	constructor: media,

	initView: function(){

		var $this = this;

		var mediaList = $this.$el.find('.media__list'),
			players = $this.$el.find('.js-audioplayer'),
			mediaFilter = $this.$el.find('.media__filter');
			filterLink = mediaFilter.find('.filter__link');

		mediaList.isotope({
			itemSelector: '.media__item',
			layoutMode: 'masonry'
		});
		
		filterLink.on('click', function(event) {
			
			var link = $(this),
				filter = link.data('filter');

			filterLink.not(this).removeClass('active');
			link.addClass('active');

			mediaList.isotope({ filter: filter });

			event.preventDefault()
		});

		players.each(function(i) {
			
			var player = $(this);

			player.audioPlayer({
				strPlay: '',
				strPause: '',
				strVolume: 'Volume'
			});

		});

	},
	init: function(){
		this.initView();
	}

}

// news.js

function news( $el ) {
	this.$el = $el;
};

news.prototype = {
	constructor: news,

	initView: function(){

		var $this = this;

		var initSlider = function() {
			$this.$el.owlCarousel({
				navigation: 		false,
				slideSpeed: 		300,
				paginationSpeed: 	400,
				singleItem: 		true,
				autoPlay: 			false
			});
		}

		var destroySlider = function() {
			if(typeof $this.$el.data('owlCarousel') != 'undefined') {
				$this.$el.data('owlCarousel').destroy();
				$this.$el.removeClass('owl-carousel');
			}
		}

		var initDot = function() {
			$this.$el.find('.news__item .news__text').dotdotdot({
				ellipsis : '...'
			});
		}
	

		detached = $this.$el.find('> div:nth-child(1n+10)');
		detached.detach();
		initSlider();

		enquire.register('screen and (min-width: 768px)', {

			deferSetup : true,
			setup : function() {
				destroySlider();
				$this.$el.append(detached);
			},
			match : function() {
				destroySlider();
				$this.$el.append(detached);
			},
			unmatch : function() {
				detached = $this.$el.find('> div:nth-child(1n+10)');
				detached.detach(); 
				initSlider();
			}

		});

		$this.$el.next('.button-wrap').find('.button').on('click', function(e){
			var all = $this.$el.find('> div').length;
			for(var i=1;i<4;i++){
				$this.news_count++;
				if($this.$el.find('> div:nth-child(' + $this.news_count + ')').length > 0){
					$this.$el.find('> div:nth-child(' + $this.news_count + ')').slideDown(500);
				}
			}
			if(all <= $this.news_count){
				$this.$el.next('.button-wrap').slideUp();
			}
			initDot();
		});

		initDot();

		

		$(window).resize(function(){
			initDot();
		});

	},
	init: function(){
		this.detached = '';
		this.news_count = this.$el.data('news-count');
		this.initView();
	}

}

// content.js

function content( $el ) {
	this.$el = $el;
};

content.prototype = {
	constructor: content,

	initView: function(){

		var $this = this,
		galleryList = $this.$el.find('.gallery__list');

		if(galleryList.length) {
			galleryList.owlCarousel({
				navigation: 		false,
				slideSpeed: 		300,
				paginationSpeed: 	400,
				singleItem: 		true,
				autoHeight: 		true,
				autoPlay: 			6666
			});
		}

	},
	init: function(){
		this.initView();
	}

}


// registration.js

$(function() {

	var form = $('.registration__form'),
		inputEmail = form.find('input[name="email"]'),
		inputUsername = form.find('input[name="username"]');

	form.find('select,input').on('change',function(){
		$(this).removeClass('error');
	});

	form.on('submit', function(event) {

		event.preventDefault();

		var error = false;
		inputUsername.val(inputEmail.val());

		$('.row.error').slideUp(200,'easeOutCubic');
		form.find('.error').removeClass('error');

		form.find('input').each(function(){
			$this = $(this);
			if($this.val().length < 1){
				$this.addClass('error');
				error = true;
			}
		});

		form.find('select').each(function(){
			$this = $(this);
			if($this.val().length < 1){
				$this.addClass('error');
				error = true;
			}
		});

		var required = form.find('[required]')
		required.each(function() {
			var type = $(this).attr('type');
			var val = $(this).val();

			if (type === 'checkbox') {
				val = $(this)[0].checked
			}

			if (!!val === false) {
				error = true
				$(this).next('.text').addClass('has-error')
				$(this).on('change', function() {
					$(this).next('.text').removeClass('has-error')
				})
			} else {
				$(this).next('.text').removeClass('has-error')
			}
		})

		if(error){

			$('.row.error_general').slideDown(200,'easeOutCubic');

		} else {

			// api - get random item
			$.ajax({
				type: 'post',
				url: form.attr('action'),
	     		data: form.serialize(),
				success:function(response) {

					var resp = jQuery.parseJSON(response);

					console.log(resp);

					if(resp.status == 'success'){

						$('.row.registration').fadeOut(250,function(){
							$(this).remove();
							$('.row.success').fadeIn(250);
						});

					} else {

						var done = false;

						$.each(resp.fields,function(index,element){
							if(!done){
								if(element.code == 'ugm_error_email_not_valid'){
									$('.error_email').slideDown();
									$('#email').addClass('error');
									done = true;
								} else if(element.code == 'ugm_error_username_existing'){
									$('.error_email_exists').slideDown();
									$('#email').addClass('error');
									done = true;
								} else if(element.code == 'ugm_error_min_max_length'){
									$('.error_password_length').slideDown();
									$('input[type=password]').addClass('error');
									done = true;
								} else if(element.code == 'ugm_error_password_confirm_match'){
									$('.error_password_match').slideDown();
									$('input[type=password]').addClass('error');
									done = true;
								}
							}
						});
					}

				}
			});

		}

	});



	// forgot password

	var forgotPasswordForm = $('.forgotPassword__form');

	forgotPasswordForm.on('submit', function(event) {

		event.preventDefault();

		$.ajax({
			type: 'post',
			url: forgotPasswordForm.attr('action'),
     		data: forgotPasswordForm.serialize(),
			success:function(response) {

				var resp = jQuery.parseJSON(response);

				if(resp.status == 'success'){

					$('.row.registration').fadeOut(250,function(){
						$('.row.success').fadeIn(250);
						$('.sent_to').text($('#email').val());
						$(this).remove();
					});

				} else {
					$('input#email').addClass('error');
				}

			}
		});

	});



	// reset password

	var resetPasswordForm = $('.resetPassword__form');

	resetPasswordForm.on('submit', function(event) {

		event.preventDefault();

		$.ajax({
			type: 'post',
			url: resetPasswordForm.attr('action'),
     		data: resetPasswordForm.serialize(),
			success:function(response) {

				var resp = jQuery.parseJSON(response);

				if(resp.status == 'success'){

					$('.row.error').slideUp(200,'easeOutCubic');

					$('.row.registration').fadeOut(250,function(){
						$(this).remove();
						$('.row.success').fadeIn(250);
					});

				} else {
					$('input.input_pw').addClass('error');

					$('.row.error').slideUp(200,'easeOutCubic');
					var done = false;

					$.each(resp.fields,function(index,element){
						if(!done){
							if(element.code == 'ugm_error_mandatory_fields' || element.code == 'ugm_error_min_max_length'){
								$('.error_new_password').slideDown();
								done = true;
							} else if(element.code == 'confirm_new_password' || element.code == 'ugm_error_password_confirm_match'){
								$('.error_match_password').slideDown();
								done = true;
							} else if(element.code == 'ugm_error_general'){
								$('.error_general').slideDown();
								done = true;
							}
						}
					});
				}

			}
		});

	});


});

// login.js

$(function() {

	var loginContainer = $('.login'),
		form = $('.login__form'),
		form_content = $('.login__form__content'),
		redirectUrl = form.attr('data-redirect-url'),
		errorMsg = form.find('.login__error'),
		redirectUrl_content = form_content.attr('data-redirect-url'),
		errorMsg_content = form_content.find('.login__error');

	$(document).on('click', '.js-login-trigger', function(event) {
		
		loginContainer.toggleClass('active');

		event.preventDefault();
	});

	$(document).on('click', '.js-form-logout', function(event) {

		var item = $(this),
			logoutRedirectUrl = item.attr('data-redirect-url');

		$.ajax({
			type: 'post',
			url: item.attr('href'),
			success:function(response) {
				window.location.href = logoutRedirectUrl;				
			}
		});

		event.preventDefault();
	});

	$(document).click(function(e) {
		if ( $(e.target).closest('.login, .js-login-trigger').length === 0 ) {
			loginContainer.removeClass('active');
		}
	});


	form.on('submit', function(event) {

		event.preventDefault();

		// api - get random item
		$.ajax({
			type: 'post',
			url: form.attr('action'),
     		data: form.serialize(),
			success:function(response) {
				
				response = $.parseJSON(response);

				if(response.status == 'success') {

					errorMsg.removeClass('active');
					window.location.href = redirectUrl;

				} else {

					errorMsg.addClass('active');

				}
				
			}
		});

	});


	form_content.on('submit', function(event) {

		event.preventDefault();

		// api - get random item
		$.ajax({
			type: 'post',
			url: form_content.attr('action'),
     		data: form_content.serialize(),
			success:function(response) {
				
				response = $.parseJSON(response);

				if(response.status == 'success') {

					errorMsg_content.removeClass('active');
					window.location.href = redirectUrl_content;

				} else {

					errorMsg_content.addClass('active');

				}
				
			}
		});

	});

});

// sharing.js

/* TWITTER */
function MM_openBrWindow (theURL, winName, features) { //v2.0
  window.open(theURL, winName, features);
}
function shareTwitter (tweet_text) {
	var u = window.location;
	MM_openBrWindow('http://twitter.com/home?status=' + encodeURIComponent(tweet_text) + ' ' + u + '', 'wTW', 'scrollbars=yes,resizable=yes');
}
function shareVK (title, link, img) {
	// var u = window.location;
  var url  = 'http://vk.com/share.php?';

  if (link) {
      url += 'url=' + encodeURIComponent(link);
  }
  if (title) {
      url += '&title=' + encodeURIComponent(title);
  }
  if (img) {
      url += '&image=' + encodeURIComponent(img);
  }
  url += '&noparse=true';

	MM_openBrWindow(url);
}
function shareWhatsapp (title, link, img) {
	// var u = window.location;
  var url  = 'https://api.whatsapp.com/send?';
  var text = title + ' - ' + link;
  url += 'text=' + text;
	MM_openBrWindow(url);
}

/* FACEBOOK */
function postToWall (title, description, link, image) {
	FB.ui({
		method: 		'feed',
		picture:		image,
		link:			link,
		caption:		title,
		description:	description,
	});
}

// overlay sharing
$(document).ready(function () {

	$(document).on('click', '.overlay a.control__link[href="#"]', function (e) {

		e.preventDefault();

		var $this = $(this);
		var $data = $this.parents('.overlay').find('h1');
		var $ovl = $this.parents('.overlay');

		if ($data.attr('data-title') === undefined) {

			var img = '';
			var title = $ovl.find('h1').text();

			var text = $ovl.find('.content__element').text();
			var pos = text.indexOf(' ', 105);
			var description = text.substring(0, pos) + '...';

			var link = window.location.href;

		} else {

			var img = $data.attr('data-teaserimage');
			var title = $data.attr('data-title');
			var description = $data.attr('data-teasertext');
			var link = $data.attr('data-siteurl');

		}

    console.log(title, link, img)

		if ($this.hasClass('control__link--fb')) {
			postToWall(title, description, link, img);
		} else if ($this.hasClass('control__link--vk')) {
      shareVK(title, link, img);
    } else if ($this.hasClass('control__link--whatsapp')) {
      shareWhatsapp(title, link, img);
    } else if ($this.hasClass('control__link--email')) {
      window.location.replace('mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(title + ' - ' + link));
    } else if ($this.hasClass('control__link--wechat')) {
    }

	});

  var link = window.location.href;

	if($('.qrcode').length){
		const qr = new QRCode($('.qrcode')[0], {
			text: link,
			width: 200,
			height: 200,
			colorDark : '#7bb32e',
			colorLight : '#ffffff',
			correctLevel : QRCode.CorrectLevel.H,
		});
	}

});


// livstream.js

$(function() {

	$('.livestream .row.stream div.play').on('click', function () {

		var $tv = $(this).closest('.row.stream').find('div.tv');
		var $src = $(this).closest('.row.stream').find('iframe').attr('src');
		var $play = $(this).closest('.row.stream').find('div.play');
		var $userid = $play.attr('data-userid');
		var $user = $play.attr('data-user');
		var $useremail = $play.attr('data-useremail');
		var $usercountry = $play.attr('data-usercountry');
		var $title = $play.attr('data-title');
		var $userInfo = $userid+'/'+$user+'/'+$useremail+'/'+$usercountry;
		//$userInfo = $userid;
		ga('send', 'event', 'Videos', $title, $userInfo);

		$src = $src.replace('autoplay=0','autoplay=1');

		$tv.addClass('over');
		$(this).closest('.row.stream').find('iframe').attr('src', $src);

	});

});

// cookiheader.js

function cookiheader ($el) {
	this.$el = $el;
};

cookiheader.prototype = {
	constructor: cookiheader,

	initView: function () {

		if (window.localStorage.acceptedCookies !== 'accepted') {
			$('.cookie_header').addClass('visible')
		}
		window.acceptCookies =  function () {
			$('.cookie_header').removeClass('visible')
			window.localStorage.acceptedCookies = 'accepted';
		}


		$('.cookie_header__content a').each(function () {
			var $t = $(this);
			$t.addClass('js-overlay-open')
			$t.attr('data-src', $t.attr('href'))
			$t.attr('data-overlay-type', 'news')
		})

	},
	init: function () {
		this.initView();
	},

}

